/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-PersonaExample .ms-Persona{margin:0 0 10px 0}.ms-JobIconExample{margin-right:5px}.exampleLabel{margin:10px 0}.customExampleCoin img{border-radius:20px}\n"}]);